(() => {
  if (window.__tjFitmentBound) return;
  window.__tjFitmentBound = true;

  const STORAGE_KEY = 'tj-fitment-vehicle';
  const FILTER_NAMES = {
    make: ['make'],
    model: ['model'],
    year: ['year'],
  };

  const STATIC_FITMENT_ROWS = Array.isArray(window.TJFitmentOptions) ? window.TJFitmentOptions : [];
  const VARIANT_FILTER_PARAMS = {
    make: 'filter.v.m.custom.make',
    model: 'filter.v.m.custom.model',
    year: 'filter.v.m.custom.year',
  };

  function staticValues(rows, key) {
    return [...new Set(rows.map((row) => String(row[key] || '').trim()).filter(Boolean))]
      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
  }

  function fillStaticSelect(select, values, placeholder, paramName) {
    fillFilterSelect(select, {
      paramName,
      values: values.map((value) => ({ value, label: value })),
    }, placeholder);
  }

  function bindStaticFinder(form, makeSelect, modelSelect, yearSelect, makePlaceholder, modelPlaceholder, yearPlaceholder) {
    const saved = readSavedVehicle();
    const refreshYears = () => {
      const rows = STATIC_FITMENT_ROWS.filter((row) => row.make === makeSelect.value && row.model === modelSelect.value);
      fillStaticSelect(yearSelect, staticValues(rows, 'year'), yearPlaceholder, VARIANT_FILTER_PARAMS.year);
      yearSelect.disabled = !makeSelect.value || !modelSelect.value;
    };
    const refreshModels = () => {
      const rows = STATIC_FITMENT_ROWS.filter((row) => row.make === makeSelect.value);
      fillStaticSelect(modelSelect, staticValues(rows, 'model'), modelPlaceholder, VARIANT_FILTER_PARAMS.model);
      modelSelect.disabled = !makeSelect.value;
      yearSelect.value = '';
      refreshYears();
    };
    fillStaticSelect(makeSelect, staticValues(STATIC_FITMENT_ROWS, 'make'), makePlaceholder, VARIANT_FILTER_PARAMS.make);
    if (saved.make) selectValue(makeSelect, saved.make);
    refreshModels();
    if (saved.model) selectValue(modelSelect, saved.model);
    refreshYears();
    if (saved.year) selectValue(yearSelect, saved.year);

    makeSelect.addEventListener('change', () => { setMessage(form, ''); refreshModels(); });
    modelSelect.addEventListener('change', () => { setMessage(form, ''); refreshYears(); });
    yearSelect.addEventListener('change', () => setMessage(form, ''));
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!makeSelect.value || !modelSelect.value || !yearSelect.value) {
        setMessage(form, 'Select your make, model and year.', true);
        return;
      }
      const row = STATIC_FITMENT_ROWS.find((item) =>
        item.make === makeSelect.value && item.model === modelSelect.value && item.year === yearSelect.value,
      );
      if (!row) {
        setMessage(form, 'This vehicle selection is unavailable.', true);
        return;
      }
      saveVehicle(form);
      window.location.href = resultsPageUrl('/collections/all', [
        { paramName: VARIANT_FILTER_PARAMS.make, value: row.filterMake || row.make },
        { paramName: VARIANT_FILTER_PARAMS.model, value: row.filterModel || row.model },
        { paramName: VARIANT_FILTER_PARAMS.year, value: row.filterYear || row.year },
      ]);
    });
  }



  function bindDynamicFinder(form, products, makeSelect, modelSelect, yearSelect, makePlaceholder, modelPlaceholder, yearPlaceholder) {
    const rows = products.flatMap((product) => window.TJFitmentIndex.expandProduct(product));
    if (!rows.length) return false;
    const saved = readSavedVehicle();
    const refreshYears = () => {
      const subset = rows.filter((row) => row.make === makeSelect.value && row.model === modelSelect.value);
      fillStaticSelect(yearSelect, staticValues(subset, 'year'), yearPlaceholder, '');
      yearSelect.disabled = !makeSelect.value || !modelSelect.value;
    };
    const refreshModels = () => {
      const subset = rows.filter((row) => row.make === makeSelect.value);
      fillStaticSelect(modelSelect, staticValues(subset, 'model'), modelPlaceholder, '');
      modelSelect.disabled = !makeSelect.value;
      yearSelect.value = '';
      refreshYears();
    };
    fillStaticSelect(makeSelect, staticValues(rows, 'make'), makePlaceholder, '');
    if (saved.make) selectValue(makeSelect, saved.make);
    refreshModels();
    if (saved.model) selectValue(modelSelect, saved.model);
    refreshYears();
    if (saved.year) selectValue(yearSelect, saved.year);
    makeSelect.addEventListener('change', () => { setMessage(form, ''); refreshModels(); });
    modelSelect.addEventListener('change', () => { setMessage(form, ''); refreshYears(); });
    yearSelect.addEventListener('change', () => setMessage(form, ''));
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const make = makeSelect.value;
      const model = modelSelect.value;
      const year = yearSelect.value;
      if (!make || !model || !year) {
        setMessage(form, 'Select your make, model and year.', true);
        return;
      }
      if (!rows.some((row) => row.make === make && row.model === model && row.year === year)) {
        setMessage(form, 'This vehicle selection is unavailable.', true);
        return;
      }
      saveVehicle(form);
      const url = new URL('/collections/all', window.location.origin);
      url.searchParams.set('view', 'fitment-results');
      url.searchParams.set('make', make);
      url.searchParams.set('model', model);
      url.searchParams.set('year', year);
      keepPreviewTheme(url);
      window.location.href = url.pathname + url.search;
    });
    return true;
  }

  function previewThemeId() {
    const current = new URL(window.location.href);
    return current.searchParams.get('preview_theme_id') || (
      window.Shopify?.designMode
        ? document.getElementById('tj-sd-filters')?.getAttribute('data-theme-id') || ''
        : ''
    );
  }

  function keepPreviewTheme(url) {
    const id = previewThemeId();
    if (id) url.searchParams.set('preview_theme_id', id);
  }

  function parseInlineFilters() {
    const el = document.getElementById('tj-sd-filters');
    const fallbackUrl = el?.getAttribute('data-results-url') || '/collections/all';
    const empty = { resultsUrl: fallbackUrl, filters: [], source: el };
    if (!el) return empty;
    try {
      const data = JSON.parse(el.textContent.trim() || 'null');
      if (data && Array.isArray(data.filters)) {
        return {
          resultsUrl: data.resultsUrl || fallbackUrl,
          filters: data.filters,
          source: el,
        };
      }
    } catch (error) {
      console.warn('Search & Discovery filter JSON is invalid', error);
    }
    return empty;
  }

  async function fetchFilters(resultsUrl, applied) {
    const url = new URL(resultsUrl || '/collections/all', window.location.origin);
    url.searchParams.set('view', 'sd-filters');
    keepPreviewTheme(url);
    (applied || []).forEach((item) => {
      if (item?.paramName && item?.value) url.searchParams.append(item.paramName, item.value);
    });
    const response = await fetch(url.pathname + url.search, { credentials: 'same-origin' });
    const text = (await response.text()).trim();
    const start = text.indexOf('{');
    const end = text.lastIndexOf('}');
    const data = JSON.parse(start >= 0 ? text.slice(start, end + 1) : text);
    if (!data || !Array.isArray(data.filters)) {
      throw new Error('Search & Discovery filters are empty');
    }
    return {
      resultsUrl: data.resultsUrl || resultsUrl,
      filters: data.filters,
    };
  }

  function findFilter(data, key) {
    const names = FILTER_NAMES[key] || [];
    const filters = data?.filters || [];
    // The storefront has legacy Product filters with the same labels. The
    // fitment data lives on variants, so choose the Variant metafield source.
    const byLabel = filters.find((filter) =>
      names.includes(String(filter.label || '').toLowerCase().trim()) &&
      String(filter.paramName || '').startsWith('filter.v.m.')
    ) || filters.find((filter) =>
      names.includes(String(filter.label || '').toLowerCase().trim())
    );
    if (byLabel) return byLabel;
    return filters.find((filter) => {
      const param = String(filter.paramName || '').toLowerCase();
      const tail = param.split('.').pop();
      return names.some((name) => tail === name || param.endsWith(`-${name}`) || param.endsWith(`_${name}`));
    });
  }

  function fillFilterSelect(select, filter, placeholder) {
    if (!select) return;
    const current = select.value;
    const values = (filter?.values || []).filter((item) => item && item.value !== '' && item.value != null);
    select.innerHTML = '';
    const empty = document.createElement('option');
    empty.value = '';
    empty.textContent = placeholder || select.getAttribute('data-placeholder') || 'Select';
    select.appendChild(empty);
    values.forEach((item) => {
      const option = document.createElement('option');
      option.value = String(item.value);
      option.textContent = String(item.label || item.value);
      select.appendChild(option);
    });
    if (filter?.paramName) select.setAttribute('data-param-name', filter.paramName);
    const active = values.find((item) => item.active);
    if (current && values.some((item) => String(item.value) === current)) {
      select.value = current;
    } else if (active) {
      select.value = String(active.value);
    }
  }

  function selectValue(select, wanted) {
    if (!select || !wanted) return false;
    const match = [...select.options].find((option) => option.value && option.value === String(wanted));
    if (!match) return false;
    select.value = match.value;
    select.disabled = false;
    return true;
  }

  function appliedFromSelects(form) {
    return [
      { key: 'make', select: form.querySelector('[data-tj-make]') },
      { key: 'model', select: form.querySelector('[data-tj-model]') },
      { key: 'year', select: form.querySelector('[data-tj-year]') },
    ]
      .map(({ key, select }) => ({
        key,
        paramName: select?.getAttribute('data-param-name') || '',
        value: select?.value || '',
      }))
      .filter((item) => item.paramName && item.value);
  }

  function readSavedVehicle() {
    const params = new URLSearchParams(window.location.search);
    try {
      const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '');
      return {
        make: params.get('make') || parsed.make || '',
        model: params.get('model') || parsed.model || '',
        year: params.get('year') || parsed.year || '',
      };
    } catch (error) {
      return {
        make: params.get('make') || '',
        model: params.get('model') || '',
        year: params.get('year') || '',
      };
    }
  }

  function saveVehicle(form) {
    const make = form.querySelector('[data-tj-make]')?.value || '';
    const model = form.querySelector('[data-tj-model]')?.value || '';
    const year = form.querySelector('[data-tj-year]')?.value || '';
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ make, model, year }));
    } catch (error) {
      /* private mode */
    }
  }

  function selectedFromData(data, saved) {
    const selected = { make: '', model: '', year: '' };
    const params = new URLSearchParams(window.location.search);
    ['make', 'model', 'year'].forEach((key) => {
      const filter = findFilter(data, key);
      const fromUrl = filter?.paramName ? params.getAll(filter.paramName)[0] : '';
      const fromActive = filter?.values?.find((item) => item.active)?.value || '';
      selected[key] = String(fromUrl || fromActive || saved[key] || '');
    });
    return selected;
  }

  function resultsPageUrl(resultsUrl, applied) {
    const url = new URL(resultsUrl || '/collections/all', window.location.origin);
    applied.forEach((item) => {
      if (item.paramName && item.value) url.searchParams.append(item.paramName, item.value);
    });
    keepPreviewTheme(url);
    return `${url.pathname}${url.search}`;
  }

  function setMessage(form, text, isError) {
    const node = form.querySelector('[data-tj-message]');
    if (!node) return;
    node.hidden = !text;
    node.textContent = text || '';
    node.classList.toggle('is-error', Boolean(isError && text));
  }

  async function bindFinder(form, initialData) {
    const makeSelect = form.querySelector('[data-tj-make]');
    const modelSelect = form.querySelector('[data-tj-model]');
    const yearSelect = form.querySelector('[data-tj-year]');
    if (!makeSelect || !modelSelect || !yearSelect) return;

    const makePlaceholder = makeSelect.getAttribute('data-placeholder') || makeSelect.options[0]?.textContent || 'Select Make';
    const modelPlaceholder = modelSelect.getAttribute('data-placeholder') || modelSelect.options[0]?.textContent || 'Select Model';
    const yearPlaceholder = yearSelect.getAttribute('data-placeholder') || yearSelect.options[0]?.textContent || 'Select Year';
    makeSelect.setAttribute('data-placeholder', makePlaceholder);
    modelSelect.setAttribute('data-placeholder', modelPlaceholder);
    yearSelect.setAttribute('data-placeholder', yearPlaceholder);

    if (form.hasAttribute('data-tj-dynamic-finder') || window.TJFitmentIndex) {
      const submit = form.querySelector('[type="submit"]');
      const retry = form.querySelector('[data-tj-retry]');
      let busy = false;
      let ready = false;
      const loadDynamic = async () => {
        if (busy || ready) return;
        busy = true;
        form.setAttribute('aria-busy', 'true');
        makeSelect.disabled = modelSelect.disabled = yearSelect.disabled = true;
        if (submit) submit.disabled = true;
        if (retry) retry.hidden = true;
        setMessage(form, '');
        fillStaticSelect(makeSelect, [], 'Loading makes…', '');
        fillStaticSelect(modelSelect, [], modelPlaceholder, '');
        fillStaticSelect(yearSelect, [], yearPlaceholder, '');
        try {
          if (!window.TJFitmentIndex) throw new Error('Vehicle index is unavailable');
          const products = await window.TJFitmentIndex.load();
          if (!bindDynamicFinder(form, products, makeSelect, modelSelect, yearSelect, makePlaceholder, modelPlaceholder, yearPlaceholder)) {
            throw new Error('Vehicle index has no fitments');
          }
          ready = true;
          makeSelect.disabled = false;
          if (submit) submit.disabled = false;
        } catch (error) {
          console.error('Dynamic vehicle finder unavailable', error);
          fillStaticSelect(makeSelect, [], makePlaceholder, '');
          setMessage(form, 'Unable to load vehicles. Please try again.', true);
          if (retry) retry.hidden = false;
        } finally {
          busy = false;
          form.setAttribute('aria-busy', 'false');
        }
      };
      form.addEventListener('submit', (event) => {
        if (!ready) event.preventDefault();
      });
      if (retry) retry.addEventListener('click', loadDynamic);
      await loadDynamic();
      return;
    }

    if (STATIC_FITMENT_ROWS.length) {
      bindStaticFinder(form, makeSelect, modelSelect, yearSelect, makePlaceholder, modelPlaceholder, yearPlaceholder);
      return;
    }

    let data = initialData;
    if (!data.filters.length) {
      try {
        data = await fetchFilters(data.resultsUrl, []);
      } catch (error) {
        setMessage(form, 'Search & Discovery Make / Model / Year filters are not available.', true);
        return;
      }
    }

    if (!findFilter(data, 'make') || !findFilter(data, 'model') || !findFilter(data, 'year')) {
      setMessage(form, 'Search & Discovery must include Make, Model and Year filters.', true);
      return;
    }

    const saved = readSavedVehicle();
    const selected = selectedFromData(data, saved);

    const loadYears = async () => {
      const applied = appliedFromSelects(form).filter((item) => item.key !== 'year');
      let next = data;
      if (makeSelect.value && modelSelect.value) {
        try {
          next = await fetchFilters(data.resultsUrl, applied);
        } catch (error) {
          next = data;
        }
      }
      fillFilterSelect(yearSelect, findFilter(next, 'year'), yearPlaceholder);
      yearSelect.disabled = !makeSelect.value || !modelSelect.value;
    };

    const loadModels = async () => {
      const applied = appliedFromSelects(form).filter((item) => item.key === 'make');
      let next = data;
      if (makeSelect.value) {
        try {
          next = await fetchFilters(data.resultsUrl, applied);
        } catch (error) {
          next = data;
        }
      }
      fillFilterSelect(modelSelect, findFilter(next, 'model'), modelPlaceholder);
      modelSelect.disabled = !makeSelect.value;
      if (!modelSelect.value) yearSelect.value = '';
      await loadYears();
    };

    fillFilterSelect(makeSelect, findFilter(data, 'make'), makePlaceholder);
    if (selected.make) selectValue(makeSelect, selected.make);
    await loadModels();
    if (selected.model) selectValue(modelSelect, selected.model);
    await loadYears();
    if (selected.year) selectValue(yearSelect, selected.year);

    makeSelect.addEventListener('change', () => {
      setMessage(form, '');
      modelSelect.value = '';
      yearSelect.value = '';
      loadModels();
    });

    modelSelect.addEventListener('change', () => {
      setMessage(form, '');
      yearSelect.value = '';
      loadYears();
    });

    yearSelect.addEventListener('change', () => setMessage(form, ''));

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const make = makeSelect.value;
      const model = modelSelect.value;
      const year = yearSelect.value;
      if (!make || !model || !year) {
        setMessage(form, 'Select your make, model and year.', true);
        return;
      }

      const applied = appliedFromSelects(form);
      if (applied.length < 3) {
        setMessage(form, 'Search & Discovery Make / Model / Year filters are not available.', true);
        return;
      }

      saveVehicle(form);
      window.location.href = resultsPageUrl(data.resultsUrl, applied);
    });
  }

  function highlightApplicableRows() {
    const rows = document.querySelectorAll('[data-tj-fit-row]');
    if (!rows.length) return;
    const saved = readSavedVehicle();
    if (!saved.make && !saved.model && !saved.year) return;
    rows.forEach((row) => {
      const make = (row.getAttribute('data-make') || '').toLowerCase();
      const model = (row.getAttribute('data-model') || '').toLowerCase();
      const year = row.getAttribute('data-year') || '';
      const makeOk = !saved.make || make.includes(String(saved.make).toLowerCase());
      const modelOk = !saved.model || model.includes(String(saved.model).toLowerCase());
      const yearOk = !saved.year || year.includes(String(saved.year));
      row.classList.toggle('is-selected', Boolean(makeOk && modelOk && yearOk));
    });
  }

  async function init() {
    const initial = parseInlineFilters();
    const forms = [...document.querySelectorAll('[data-tj-finder]')];
    await Promise.all(forms.map((form) => bindFinder(form, initial)));
    highlightApplicableRows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
